import React from 'react';
import img from '../../../assets/banner.webp'
import './Banner.css'
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div className='img-overlay relative block'>
            <img className='w-full h-screen ' src={img} alt=''></img>
            <div className='absolute top-1/3 z-10 w-full px-2'>
                <h1 className="md:text-6xl text-3xl text-center text-warning z-10">Enjoy a Luxury Experience</h1>
                <p className='md:w-1/2 w-full mx-auto my-7 md:text-lg px-5'>Welcome to the best five-star deluxe hotel in New York. Hotel elementum sesue the aucan vestibulum aliquam justo in sapien rutrum volutpat. Donec in quis the pellentesque velit. Donec id velit ac arcu posuere blane</p>
                <div>
                    <Link to="services" className='flex'>
                        <button className="btn btn-outline btn-accent  mx-auto">Services <AiOutlineArrowRight></AiOutlineArrowRight></button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Banner;